import { useCallback, useState, useMemo, useEffect, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import { BsFillPencilFill } from 'react-icons/bs';
import FullWidthCellRenderer from "./fullWidthCellRenderer";
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import styles from "./tables.module.css";
import moment from 'moment';
import Moment from 'react-moment';
import { MdCircle, MdError } from 'react-icons/md';
import { FaTimesCircle, FaExclamationCircle, FaCheckCircle } from "react-icons/fa";
    


import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";


export default function DeviceTable() {
    const [rowData, setRowData] = useState([]);
    const [emailAddr, setemailAddr] = useState("");
    const [searchQuery, setSearchQuery] = useState('');
    const [hideOutOfService, setHideOutOfService] = useState(false);
    const narrowView = window.innerWidth < 500 ? true : false;
    const gridRef = useRef();

    const [originalData, setOriginalData] = useState([]);
    const tankThresholds = JSON.parse(localStorage.getItem("tankThresholds") || "{}");

    //for the service toggle
    const toggleDevice = async (deviceID) => {
        const updatedRow = rowData.find(dev => dev.deviceID === deviceID);
        if (!updatedRow) {
            console.warn("Device not found:", deviceID);
            return;
        }
    
        const newStatus = !updatedRow.outOfService;
    
        try {
            const res = await fetch("/api/v1/markOutOfService/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-API-KEY": "7EAFDEADBEEF"
                },
                body: JSON.stringify({
                    deviceID: deviceID,
                    outOfService: newStatus,
                    deviceType: updatedRow.deviceType
                })
            });
    
            if (res.ok) {
                toast.success(`Device ${deviceID} status updated`);
                // Update local rowData without re-fetch
                setRowData(prev =>
                    prev.map(dev =>
                        dev.deviceID === deviceID
                            ? { ...dev, outOfService: newStatus }
                            : dev
                    )
                );
            } else {
                console.error("API call failed:", await res.text());
                toast.error("Failed to update status");
            }
        } catch (err) {
            console.error("Error calling toggle API", err);
            toast.error("Network error while toggling device");
        }
    };
    
    
    

    //for the search
    const filterDevices = (data, query, hideOut) => {
        return data.filter((item) => {
          const lowerQuery = query.toLowerCase();
          const matchesSearch =
            item.deviceID.toLowerCase().includes(lowerQuery) ||
            item.displayName?.toLowerCase().includes(lowerQuery); // include cannon number
          const matchesService = !hideOut || !item.outOfService;
          return matchesSearch && matchesService;
        });
      };


    function pingDevices() {
        const headers = { 'X-API-KEY': '7EAFDEADBEEF' };
        fetch('/api/v1/statusPollAll/', { headers })
            .then((response) => {
                setTimeout(function () { fetchTableData(); }, 1000);
            });
    }

    function fireDevices() {
        const rowsToFire = gridRef.current.api.getSelectedRows();

        let IDList = [];
        rowsToFire.forEach((element) => {
            IDList.push(element.deviceID);
        });
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-API-KEY': '7EAFDEADBEEF'
            },
            body: JSON.stringify(IDList)
        };
        fetch('/api/v1/fireList/', requestOptions)
            .then(response => response.json())  // Convert the response to JSON
            .then(arrayList => {
                arrayList.forEach(item => {
                    if (item.success === false) {
                        toast.warn("No Reponse from: " + item.deviceID);
                    }
                })
            })
    }

    useEffect(() => {
        fetchTableData()
        document.addEventListener('dataRefresh', (event) => {
            fetchTableData();
        });
    }, []);

    async function fetchTableData() {
        if (!gridRef.current || !gridRef.current.api) {
            console.warn("Grid is not ready, skipping fetchTableData()");
            return;
          };
        try {
            const headers = { 'X-API-KEY': '7EAFDEADBEEF' };
            const response = await fetch('/api/v1/statusAll/', { headers });
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            const data = await response.json();

            if (data.length > 0) {
                // Create rows
                let rowList = [];
                const now = moment();

                data.forEach(obj => {
                    const lastHeard = moment(obj.recordDate);
                    const daysAgo = now.diff(lastHeard, 'days');

                    if (daysAgo <= 30) {  // Only include if within last 30 days
                        let row = Object.assign({}, obj);
                        if (obj.displayname)
                            row = Object.assign(row, { displayName: obj.displayname.displayName });
                        row = Object.assign(row, { isFullWidthDetail: false });
                        rowList.push(row);
                    }
                });

                toast.success("Data Fetched");

                if (gridRef.current && gridRef.current.api) {
                    gridRef.current.api.sizeColumnsToFit();
                  };
                  

                setOriginalData(rowList); // for search
                setRowData(filterDevices(rowList, searchQuery, hideOutOfService)); // Filter on fetch for search

            } else {
                toast.error("No Data");
            }
        } catch (error) {
            toast.error("Error fetching data");
            console.error('Error fetching data:', error);
            return;
        }

        gridRef.current.api.sizeColumnsToFit()
    }

    function ActionButtons(props) {
        return <div><button className="btn btn-danger" ref={(ref) => {
            if (!ref) return;
            //attach onClick event handler to the real DOM element
            ref.onclick = (e) => {
                e.stopPropagation();
                if (props.data.displayName)
                    toast("FIRING! " + props.data.displayName)
                else
                    toast("FIRING! " + props.data.deviceID)

                const headers = { 'X-API-KEY': '7EAFDEADBEEF' };
                fetch('/api/v1/fireSingle/' + props.data.deviceID + "/", { headers })
                    .then(response => response.json())  // Convert the response to JSON
                    .then(responseJSON => {
                        if (responseJSON.success === false)
                            toast.warn("No Reponse from: " + props.data.deviceID);
                    });
            };
        }}>
            Fire
        </button >{' '}
        {/* NEW: Fire EXT button */}
        <button
            className="btn btn-warning"
            ref={(ref) => {
            if (!ref) return;
            ref.onclick = (e) => {
                e.stopPropagation();
                if (props.data.displayName) toast(`FIRING EXT! ${props.data.displayName}`);
                else toast(`FIRING EXT! ${props.data.deviceID}`);

                const headers = { "X-API-KEY": "7EAFDEADBEEF" };
                // API call
                fetch(`/api/v1/fireEXTSingle/${props.data.deviceID}/`, { headers })
                .then((response) => response.json())
                .then((responseJSON) => {
                    if (responseJSON.success === false) {
                    toast.warn(`No Response (EXT) from: ${props.data.deviceID}`);
                    }
                })
                .catch((err) => {
                    console.error("Fire EXT error:", err);
                    toast.error("Fire EXT request failed");
                });
            };
            }}
        >
            Fire EXT
        </button>{" "}



            <button className="btn btn-secondary">
                Details
            </button >
        </div >
    }

    const greenCircleStyles = {
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        margin: '2px',
        backgroundColor: 'green',
    };

    function statusCellRenderer(props) {
        const batteryV = props.data.batteryV;
        const tankCounter = props.data.tankCounter;
        const lifeCounter = props.data.lifeCounter ?? 0;
        const recordDate = moment(props.data.recordDate);
        const type = props.data.deviceType?.toLowerCase() || "";
        const tankThresholds = JSON.parse(localStorage.getItem("tankThresholds") || "{}");

        // Determine dynamic tank threshold
        let threshold = 15000;
        const match = Object.keys(tankThresholds).find(key =>
            type.includes(key.toLowerCase())
        );
        if (match) threshold = tankThresholds[match];

        let statusLevel = 0;
        let statusMessage = "OK";

        // 1. MIA (highest priority)
        if (moment().diff(recordDate, 'hours') > 24) {
            statusLevel = 2;
            statusMessage = "MIA";
        }

        // 2. Life Counter check
        if (lifeCounter > 5000000 && statusLevel < 2) {
            statusLevel = 2;
            statusMessage = "High Shots";
        }

        // 3. Tank Counter
        if (tankCounter >= threshold && statusLevel < 2) {
            statusLevel = 2;
            statusMessage = "Empty Tank";
        }

        // 4. Battery checks
        if ((batteryV < 10.5 || batteryV > 15.0) && statusLevel < 2) {
            statusLevel = 2;
            statusMessage = batteryV < 10.5 ? "Low Battery" : "High Battery";
        } else if (
            (batteryV >= 10.5 && batteryV < 11.0) ||
            (batteryV > 14.0 && batteryV <= 15.0)
        ) {
            if (statusLevel < 1) {
                statusLevel = 1;
                statusMessage = "Check Battery";
            }
        }

        // Icon and color
        let IconComponent = FaCheckCircle;
        let color = "green";
        if (statusLevel === 1) {
            IconComponent = FaExclamationCircle;
            color = "goldenrod";
        } else if (statusLevel === 2) {
            IconComponent = FaTimesCircle;
            color = "red";
        }

        return (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <IconComponent size="20px" color={color} />
                <span>{statusMessage}</span>
            </div>
        );
    }



      
     

    function nameFieldRender(props) {
        return <div >
            {props.value}{' '}
            <BsFillPencilFill />
        </div >
    }

    function sendEmail(props) {
        console.log(emailAddr);
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-API-KEY': '7EAFDEADBEEF'
            },
            body: JSON.stringify({ "emails": emailAddr })
        };
        fetch('/api/v1/statusAllEmail/', requestOptions);
    }

    const [columnDefs] = useState([

        
        {
            headerName: 'Cannon Number', field: 'displayName', headerCheckboxSelection: true, checkboxSelection: true, cellRenderer: nameFieldRender, flex: '2', editable: true, valueSetter: params => {
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'X-API-KEY': '7EAFDEADBEEF' },
                    body: JSON.stringify({ deviceID: params.data.deviceID, displayName: params.newValue })
                };
                fetch('/api/v1/nameUpdate/', requestOptions);
                params.data.displayName = params.newValue;
            }
        },
        { headerName: 'Board ID', field: 'deviceID', flex: '2' },
        {
        headerName: 'Device Type',
        field: 'deviceType',
        editable: true,
        cellEditor: 'agSelectCellEditor',
        cellEditorParams: {
            values: [
            "Converted Float Cannon",
            "Converted Land Cannon",
            "Margo Float Cannon",
            "Margo Float SquawkBox",
            "Margo Land Cannon"
            ]
        },
        onCellValueChanged: (params) => {
            const updatedType = params.newValue;
            const deviceID = params.data.deviceID;

            fetch('/api/v1/markOutOfService/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-API-KEY': '7EAFDEADBEEF',
            },
            body: JSON.stringify({
                deviceID,
                outOfService: params.data.outOfService,
                deviceType: updatedType,
            }),
            })
            .then(res => {
            if (!res.ok) throw new Error("Update failed");
            return res.json();
            })
            .then(() => {
            toast.success(`Updated type for ${deviceID}`);
            })
            .catch(err => {
            console.error("Type update error:", err);
            toast.error("Failed to update device type");
            });
        },
        flex: 2
        },

        {
            headerName: "Out of Service",
            field: "outOfService",
            sortable: true,
            cellRenderer: (params) => {
                if (!params.data) return null;
              
                const isOut = !!params.data.outOfService;
                const labelText = isOut ? "Out of Service" : "In Service";
                const labelClass = isOut ? "text-danger" : "text-success";
              
                return (
                  <div
                    className="switch-cell custom-switch form-check form-switch"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id={`toggle-${params.data.deviceID}`}
                      checked={isOut}
                      onChange={() => {
                        const headers = {
                          'X-API-KEY': '7EAFDEADBEEF',
                          'Content-Type': 'application/json'
                        };
                        fetch('/api/v1/markOutOfService/', {
                          method: 'POST',
                          headers,
                          body: JSON.stringify({
                            deviceID: params.data.deviceID,
                            outOfService: !isOut
                          })
                        })
                        .then(res => res.json())
                        .then(() => {
                          params.node.setData({
                            ...params.data,
                            outOfService: !isOut
                          });
                        })
                        .catch(err => {
                          console.error("Failed to toggle:", err);
                        });
                      }}
                    />
                    <label
                      className={`form-check-label ${labelClass}`}
                      htmlFor={`toggle-${params.data.deviceID}`}
                    >
                      {labelText}
                    </label>
                  </div>
                );
              }
              
        },
        
        
        {
            headerName: 'Last Heard',
            field: 'recordDate',
            flex: 2,
            valueFormatter: (params) => {
                return moment(params.value).format("DD-MMM-YY, hh:mm a");
            }
        },
        { 
            headerName: 'Status',
            field: 'status',
            flex: '1',
            cellRenderer: statusCellRenderer,
            sortable: true,
            // Define a valueGetter that returns a value based on the condition
            valueGetter: (params) => {
                const batteryV = params.data.batteryV;
                const tankCounter = params.data.tankCounter;
                const lifeCounter = params.data.lifeCounter ?? 0;
                const recordDate = moment(params.data.recordDate);
                const type = params.data.deviceType?.toLowerCase() || "";
                const tankThresholds = JSON.parse(localStorage.getItem("tankThresholds") || "{}");

                let threshold = 15000;
                const match = Object.keys(tankThresholds).find(key =>
                    type.includes(key.toLowerCase())
                );
                if (match) threshold = tankThresholds[match];

                if (moment().diff(recordDate, 'hours') > 24) return 6;          // MIA
                if (lifeCounter > 5000000) return 5;                            // Life Counter
                if (tankCounter >= threshold) return 4;                         // Tank Full
                if (batteryV < 10.5 || batteryV > 15.0) return 3;               // Battery Critical
                if ((batteryV >= 10.5 && batteryV < 11.0) || (batteryV > 14.0 && batteryV <= 15.0)) return 2; // Battery Warning

                return 1; // OK
            }


         },

                  
        { field: 'action', minWidth: 150, flex: '2', cellRenderer: ActionButtons, },
    ])

    const rowClick = useCallback((params) => {
        // Ignore clicks on the first two columns to prevent toggling selection
        const columnIndex = params.columnApi.getAllDisplayedColumns().indexOf(params.column);
        if (columnIndex < 4) {
        return; // Do not toggle selection for the first two cells of each row
        }
        //Rework data
        const clickedRow = params.data;
        if (clickedRow.isFullWidthDetail || params.column.colId === 'name')
            return;
        let currentFullWidth = '';
        let newArray = [];
        //Find current full width
        gridRef.current.api.forEachNode(function (node) {
            if (node.data.isFullWidthDetail) {
                currentFullWidth = node.data.deviceID;
            }
        });
        //Re-add existing data
        gridRef.current.api.forEachNode(function (node) {
            const nodeID = node.data.deviceID;
            //Add none detail rows
            if (!node.data.isFullWidthDetail) {
                newArray.push(node.data);
            }

            //Insert new detail row from clicked row
            if ((nodeID === clickedRow.deviceID) && (!node.data.isFullWidthDetail) && (clickedRow.deviceID !== currentFullWidth)) {
                let newRow = Object.assign({}, node.data);
                newRow.isFullWidthDetail = true;
                newArray.push(newRow);
            }
        });
        setRowData(newArray);
        gridRef.current.api.sizeColumnsToFit();

          
    }, []);

    const getRowHeight = useCallback((params) => {
        // return larger height for full width rows
        if (params.data.isFullWidthDetail) {
            if (narrowView)
                return 700;
            else
                return 310;
        } else {
            return 46;
        }
    }, []);

    const isFullWidthRow = useCallback((params) => {
        return params.rowNode.data.isFullWidthDetail;
    }, []);

    const fullWidthCellRenderer = useMemo(() => {
        return FullWidthCellRenderer;
    }, []);

    const gridOptions = {
        columnDefs: columnDefs,

            // enables pagination in the grid
        pagination: true,

            // sets 10 rows per page (default is 100)
        paginationPageSize: 10,


        defaultColDef: {
            sortable: true,
            resizable: true,
        },
        
        
        suppressHorizontalScroll: true,
        rowSelection: 'multiple',
        onCellClicked: rowClick,
        suppressRowClickSelection: true,
        isFullWidthRow: isFullWidthRow,
        fullWidthCellRenderer: fullWidthCellRenderer,
        getRowHeight: getRowHeight,
        enableCellTextSelection: true,
        statusBar: {
            statusPanels: [{ statusPanel: 'agAggregationComponent' }],
        },
    };


    
    return (
        <div>
            <div className='mb-2'>
                <Form >
                    <Row>
                        <Col >
                            <Button onClick={fireDevices} variant="danger"> Fire Selected </Button> {' '}                            
                            <Button onClick={pingDevices} variant="primary"> Check Cannon Status </Button>
                        </Col>
                        <Col>
                            <Form.Control type="email" value={emailAddr} onChange={(e) => setemailAddr(e.target.value)} placeholder="Enter email" />
                        </Col>
                        <Col>
                            <Button onClick={sendEmail} variant="primary"> Send Report </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
            <div className={`ag-theme-alpine ${styles.tablecontainer}`}>

            <Row className="mb-2">
            <Col md={4}>
    <Form.Control
      type="text"
      placeholder="Search by Board ID"
      value={searchQuery}
      onChange={(e) => {
        setSearchQuery(e.target.value);
        setRowData(filterDevices(originalData, e.target.value, hideOutOfService));
      }}
    />
  </Col>

  <Col md="auto">
    <Form.Check
      type="checkbox"
      id="hide-out-of-service"
      label="Hide: Out of Service"
      checked={hideOutOfService}
      onChange={(e) => {
        const hide = e.target.checked;
        setHideOutOfService(hide);
        setRowData(filterDevices(originalData, searchQuery, hide));
      }}
      className="ms-2 fs-6"
    />
  </Col>
            </Row>


                <AgGridReact
                    ref={gridRef}
                    rowData={rowData}
                    gridOptions={gridOptions}
                    onGridReady={fetchTableData}>
                </AgGridReact>
            </div>
        </div>
    );
};